<div
  [formGroup]="form"
  class="flex justify-between gap-4 py-2 px-6 items-center"
>
  <mat-form-field class="input-tg mt-message-input w-3/4" appearance="outline">
    <mat-label>Descrição</mat-label>
    <input matInput formControlName="description" maxlength="100" />
  </mat-form-field>
  <button
    mat-flat-button
    class="btn-tg w-1/5"
    [disabled]="form.invalid || loading"
    (click)="createItem()"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Adicionar Novo
    }
  </button>
</div>
